export const enum BuildingReviewLandingAutocompleteStatechartEvent {
  /**
   * User is typing inside autocomplete
   */
  typing = 'typing',

  /**
   * Successfully fetched list items from backend
   */
  fetchListItemsSucceeded = 'fetchListItemsSucceeded',

  /**
   * Cleared autocomplete input area
   */
  clearedAutocomplete = 'clearedAutocomplete',

  /**
   * Selected list item from autocomplete dropdown
   */
  selectedListItem = 'selectedListItem',

  /**
   * Autocomplete has list items to show
   */
  hasListItems = 'hasListItems',

  /**
   * Autocomplete has no list items to show
   */
  hasNoListItems = 'hasNoListItems',
}
